// extracted by mini-css-extract-plugin
export default {"content-center":"MakeTransfer_content-center__PNESN","form":"MakeTransfer_form__K+2F6","w-80":"MakeTransfer_w-80__gremP"};